export const META_PROVIDER = "meta";

export const META_OAUTH_POPUP_NAME = "gail-meta-oauth";

/** Kept open: the set is Meta's to extend, and an unknown value must not crash the mapper. */
export type MetaFormStatus = "ACTIVE" | "ARCHIVED" | (string & {});

export type MetaLeadForm = {
  id: string;
  name: string;
  /** Carried, never filtered on: a live binding may point at an archived form. */
  status: MetaFormStatus;
};

export type MetaPageForms = {
  pageId: string;
  /** As of connect time. A Page renamed on Facebook keeps its old name until reconnected. */
  pageName: string;
  forms: MetaLeadForm[];
  /** Partial success: this Page's forms could not be read while the others still work. */
  error: string | null;
};

/**
 * `error`, `notConnected` and an empty `pages` must stay three separate answers:
 * rendering a failed read as "no forms" or "connect Meta first" sends a customer
 * to redo a setup that is already correct.
 *
 * Here rather than beside the hook so pure helpers can use it without importing
 * a `"use client"` module.
 */
export type MetaLeadFormsState = "loading" | "loaded" | "notConnected" | "error";

export type MetaLeadFormsResult =
  | { status: "loaded"; pages: MetaPageForms[] }
  | { status: "notConnected" }
  | { status: "error" };
